import * as moment from "moment";
import * as firebase from "firebase";

export class Timeframe {
  begin: Date;
  end: Date;
  constructor(
    begin: firebase.firestore.Timestamp,
    end: firebase.firestore.Timestamp
  ) {
    this.begin = begin.toDate();
    this.end = end != null ? end.toDate() : null;
  }

  includes(date: Date): boolean {
    if (this.end == null) return false;
    else
      return (
        date.getTime() > this.begin.getTime() &&
        date.getTime() < this.end.getTime()
      );
  }

  toJSON() {
    return {
      begin: firebase.firestore.Timestamp.fromDate(this.begin),
      end:
        this.end == null
          ? null
          : firebase.firestore.Timestamp.fromDate(this.end)
    };
  }

  toString() {
    return moment(this.begin).format("MM/DD/YY") + this.end == null
      ? ""
      : " - " + moment(this.end).format("MM/DD/YY");
  }
}
